<template>
    <b-modal size="lg" v-model="itemVisible" :title="title" @ok="handleOk">
        <officer-master-items
            v-if="useOfficerList"
            :officer-master-items="officerMasterItems"
            v-model="selectedItems"
        />
        <b-form ref="form" v-else @submit.stop.prevent="handleSubmit">
            <div>
                <b-tabs content-class="mt-3" v-if="isTask">
                    <b-tab title="General" active>
                        <portal-target name="generalItemView"> </portal-target>
                    </b-tab>
                    <b-tab title="Task" :disabled="!isTask">
                        <ViewTask
                            v-model="itemModel"
                            :master-item="masterItem"
                            :disabled="isCompleted"
                        >
                        </ViewTask>
                    </b-tab>
                </b-tabs>

                <portal to="generalItemView" :disabled="!isTask">
                    <b-form-row>
                        <b-col cols="12">
                            <b-form-group
                                id="input-group-item"
                                label="Master Item*:"
                                label-for="input-item"
                                invalid-feedback="Master Item is required"
                            >
                                <master-item-type-ahead
                                    @set-master-item="setMasterItem"
                                    @update-item-type="updateItemType"
                                    :item-type-id="itemModel.order_item_type_id"
                                    :order-type="orderModel.order_type_id"
                                    v-model="itemModel.master_item_id"
                                    :disabled="!!itemModel.id"
                                ></master-item-type-ahead>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12">
                            <b-form-group
                                id="input-group-description"
                                label="Description:"
                                label-for="input-description"
                            >
                                <b-form-input
                                    id="input-description"
                                    name="input-description"
                                    size="sm"
                                    placeholder="Description Name"
                                    v-model="itemModel.description"
                                    :disabled="isCompleted"
                                />
                            </b-form-group>
                        </b-col>

                        <b-col>
                            <b-form-group
                                id="input-group-quantity"
                                label="Quantity:"
                                label-for="input-quantity"
                            >
                                <b-form-input
                                    id="input-quantity"
                                    name="input-quantity"
                                    size="sm"
                                    placeholder="Quantity"
                                    type="number"
                                    v-model="itemModel.quantity"
                                    :disabled="isCompleted"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col v-if="isOrderItem">
                            <b-form-group
                                id="input-group-price"
                                label="Price:"
                                label-for="input-price"
                            >
                                <b-form-input
                                    id="input-price"
                                    name="input-price"
                                    size="sm"
                                    placeholder="Price"
                                    type="number"
                                    min="0.01"
                                    max="100000"
                                    v-model="itemModel.price"
                                    :disabled="isCompleted"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col v-if="isOrderItem">
                            <b-form-group
                                id="input-group-uom"
                                label="UOM:"
                                label-for="input-uom"
                            >
                                <b-form-input
                                    id="input-uom"
                                    name="input-uom"
                                    size="sm"
                                    placeholder="UOM"
                                    type="text"
                                    v-model="itemModel.uom"
                                    :disabled="isCompleted"
                                />
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                </portal>
            </div>

            <b-collapse v-model="locationCollapseVisible">
                <b-form-row>
                    <b-col cols="6">
                        <b-form-group
                            id="input-group-section_from_id"
                            label="From Bin:"
                            label-for="input-section_from_id"
                        >
                            <b-form-select
                                v-if="fromBinText == warehouse_message"
                                id="input-section_from_id"
                                v-model="itemModel.section_from_id"
                                :options="
                                    locationSections | filterLocationOptions
                                "
                                :disabled="isCompleted"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled
                                        >{{ fromBinText }}
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                            <b-form-input
                                v-else
                                id="input-section_from_id"
                                readonly
                                :value="fromBinText"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group
                            id="input-group-section_to_id"
                            label="To Bin:"
                            label-for="input-section_to_id"
                        >
                            <b-form-select
                                v-if="toBinText == warehouse_message"
                                id="input-section_to_id"
                                :options="
                                    locationSections | filterLocationOptions
                                "
                                v-model="itemModel.section_to_id"
                                :disabled="isCompleted"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled
                                        >{{ toBinText }}
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                            <b-form-input
                                v-else
                                id="input-section_to_id"
                                readonly
                                :value="toBinText"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </b-collapse>

            <b-collapse v-model="assetCollapseVisible">
                <view-assets
                    v-model="itemModel.assets"
                    :customer_id="orderModel.customer_id"
                    :customer-assets="customerAssets"
                    :disabled="isCompleted"
                />
            </b-collapse>
        </b-form>

        <template #modal-footer="{ ok }">
            <b-button
                v-if="!useOfficerList"
                :disabled="(x => !!(x.is_discount || x.is_task))(itemType)"
                @click="locationCollapseVisible = !locationCollapseVisible"
                class="m-1"
                size="sm"
                >Toggle BIN Locations</b-button
            >
            <b-button
                v-if="isCustomerEntity && isOutboundFlow"
                :disabled="!!itemType.is_discount"
                @click="assetCollapseVisible = !assetCollapseVisible"
                class="m-1"
                size="sm"
                >Toggle Assets</b-button
            >
            <b-button
                :disabled="submitting"
                variant="secondary"
                @click="itemVisible = false"
                class="m-1"
                size="sm"
                >Cancel</b-button
            >
            <b-button
                v-if="!isCompleted"
                :disabled="
                    submitting || (useOfficerList && selectedItems.length == 0)
                "
                variant="primary"
                class="m-1"
                size="sm"
                @click="ok"
                >{{ submitTitle }}</b-button
            >
        </template>
    </b-modal>
</template>

<script lang="js">
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import ViewAssets from '@/components/ViewAssets'
import MasterItemTypeAhead from '@/components/MasterItemTypeAhead'
import OfficerMasterItems from './OfficerMasterItems.vue'
import ViewTask from './ViewTask.vue'

const defaultItemModel = Object.freeze({
    id: null,
    name: '',
    order_item_type_id: null,
    master_item_id: null,
    hash: null,
    description: '',
    section_from_id: null,
    section_to_id: null,
    quantity: 0,
    uom:null,
    price: 0,
    assets: [],
    task_value: null,
    task_checked: 0,
    task_notes: '',
})

const system_message = 'System Selected'
const warehouse_message = 'Select Section'
const blackhole_message = 'None'

export default {
    name: 'orders-ViewItem',
    components: {
        ViewAssets,
        MasterItemTypeAhead,
        OfficerMasterItems,
        ViewTask,
    },
    mixins: [popupMixins, permissionsMixins],
    props: ['officer', 'orderModel', 'customerAssets'],
    data() {
        return {
            selectedItems: [],
            locationCollapseVisible: false,
            assetCollapseVisible: false,

            itemVisible: false,
            submitting: false,
            salesTax: 0,

            itemModel: {},

            //////

            system_message,
            warehouse_message,
            blackhole_message,
            masterItem: {},
        }
    },

    filters: {
        filterLocationOptions(sections) {
            return sections
                .filter(x => !x.is_officer)
                .map(s => ({
                    text: `${s.name}, ${s.location.address1},  ${s.location.city}`,
                    value: s.id,
                }))
        },
    },

    computed: {
        fromBinText() {
            const {
                isOutboundFlow,
                isInboundFlow,
                isInternalReferenceEntity,
                isBlackholeReferenceEntity,
                isInternalEntity,
            } = this
            return (isOutboundFlow && isInternalReferenceEntity) ||
                (isInboundFlow && isInternalEntity)
                ? warehouse_message
                : isOutboundFlow && isBlackholeReferenceEntity
                ? blackhole_message
                : system_message
        },
        toBinText() {
            const {
                isOutboundFlow,
                isInboundFlow,
                isInternalReferenceEntity,
                isInternalEntity,
                isBlackholeReferenceEntity,
            } = this
            return (isOutboundFlow && isInternalEntity) ||
                (isInboundFlow && isInternalReferenceEntity)
                ? warehouse_message
                : isInboundFlow && isBlackholeReferenceEntity
                ? blackhole_message
                : system_message
        },
        title() {
            return this.itemModel.id
                ? `Edit ${this.masterItem.name || 'Item'}`
                : this.isOfficerEntity
                ? 'Select Items'
                : 'Create Item'
        },

        useOfficerList() {
            return this.isOfficerEntity && !this.itemModel.id
        },

        isInboundFlow() {
            return this.flows['Inbound'] == this.transaction_type.flow
        },
        isOutboundFlow() {
            return this.flows['Outbound'] == this.transaction_type.flow
        },
        isOfficerEntity() {
            return this.entities['Officer'] == this.transaction_type.entity
        },
        isCustomerEntity() {
            return this.entities['Customer'] == this.transaction_type.entity
        },
        isInternalEntity() {
            return this.entities['Internal'] == this.transaction_type.entity
        },
        isBlackholeEntity() {
            return this.entities['Black Hole'] == this.transaction_type.entity
        },
        isCustomerReferenceEntity() {
            return (
                this.entities['Customer'] ==
                this.transaction_type.reference_entity
            )
        },
        isInternalReferenceEntity() {
            return (
                this.entities['Internal'] ==
                this.transaction_type.reference_entity
            )
        },

        isBlackholeReferenceEntity() {
            return (
                this.entities['Black Hole'] ==
                this.transaction_type.reference_entity
            )
        },

        flows() {
            return this.$store.getters['transactionType/flows']
        },
        entities() {
            return this.$store.getters['transactionType/entities']
        },
        transaction_type() {
            const { orderModel, orderTypes } = this
            console.log(' { orderModel, orderTypes }..............', {
                orderModel,
                orderTypes,
            })
            const order_type_id = orderModel && orderModel.order_type_id
            const type = orderTypes.find(x => x.id == order_type_id)
            console.log('type:..............', type)
            return (type && type.transaction_type) || {}
        },

        officerMasterItems() {
            const parseOfficerSection = (sections, section_id) => {
                sections = sections || []
                const section = sections.find(
                    x => x.location_section_id === section_id
                )
                return section || {}
            }

            const { storedItems, masterItem } = this
            const { location_section_id } = this.officer

            console.log('officerMasterItems:', masterItem)
            const _items = (masterItem && masterItem.section_items||[]).map(x => {
                const section = parseOfficerSection(
                    x.sections,
                    location_section_id
                )
                delete x.sections
                x.quantity = section.quantity_on_hand
                x.exists = storedItems.some(y => y.master_item_id == x.id)
                return x
            })

            return _items && _items.filter(x => x.quantity > 0)
        },

        order_id() {
            return this.orderId || this.$route.params.id
        },
        submitTitle() {
            console.log('this.itemModel', this.itemModel)
            return this.itemModel.id && this.submitting
                ? 'Updating Item...'
                : this.itemModel.id
                ? 'Update Item'
                : this.submitting
                ? 'Creating Item...'
                : !this.useOfficerList ||
                  (this.useOfficerList && this.selectedItems.length == 1)
                ? 'Create Item'
                : 'Create Items'
        },

        isCompleted() {
            return !!this.orderModel.completed
        },

        storedItems() {
            return this.$store.state.orderItemStore.items
        },
        locationSections() {
            return this.$store.getters['locations/locationSections']
        },

        itemTypes() {
            return this.$store.state.itemType.items
        },
        orderTypes() {
            return this.$store.state.orderType.items
        },
        itemType() {
            console.log("......................>>>>>>>>>>>>>>",this.itemModel)
            const { order_item_type_id } = this.itemModel
            if (!order_item_type_id)
                return {
                    is_discount: true,
                }
            else
                return (
                    this.itemTypes.find(x => order_item_type_id === x.id) || {}
                )
        },
        isTask() {
            return !!this.itemType.is_task
        },

        isOrderItem() {
            return !!this.itemType.is_order_item
        },
    },
    watch: {
        entities: function (val) {
            console.log('entities--', val)
        },
        flows: function (val) {
            console.log('flows--', val)
        },
        transaction_type: {
            handler: function (val) {
                console.log('transaction type--', val)
            },
            deep: true,
        },
        orderModel: {
            handler: function (val) {
                console.log('orderModel--', val)
            },
            deep: true,
        },

        'this.$store.state.masterItem': {
            handler: function (val) {
                this.masterItem = val
                console.log('masterItem', val)
            },
            deep: true,
        },
        masterItem: {
            handler: function (val) {
                if (
                    val &&
                    (this.itemModel.task_value == null ||
                        typeof this.itemModel.task_value == 'undefined')
                ) {
                    console.log('bingo------val', val)
                    console.log('bingo------item', this.itemModel)
                    this.$set(this.itemModel, 'task_value', val.default_value)
                }
            },
            deep: true,
        },
    },

    mounted() {
        this.$store.dispatch('locations/fetchWarehouses')
        this.$store.dispatch('itemType/fetchAll')
        //default the section_to_id to the delivery address....
        const section_to_id =
            this.itemModel.section_to_id ||
            this.orderModel.delivery_location_section_id
        this.$set(this.itemModel, 'section_to_id', section_to_id)
        this.masterItem = this.$store.state.masterItem
    },

    methods: {
        //////////////////////
        updateItemType(evt) {
            this.$set(this.itemModel, 'order_item_type_id', evt)
            this.locationCollapseVisible = false
            this.assetCollapseVisible = false
        },
        setMasterItem(masterItem) {
            console.log('setMasterItem:', masterItem)
            this.masterItem = masterItem || {}
            this.itemModel.description = this.masterItem.description
            this.itemModel.name = this.masterItem.name
            this.itemModel.price = this.masterItem.selling_price
            this.itemModel.uom = this.masterItem.uom
            this.itemModel.master_item_id = this.masterItem.id
            this.itemModel.quantity = 0
        },

        showItem(item) {
            console.log('showItem item before', item)

            this.itemVisible = true

            if (item) {
                let {
                    id,
                    name,
                    order_item_type_id,
                    master_item_id,
                    hash,
                    description,
                    section_from_id,
                    section_to_id,
                    quantity,
                    price,
                    assets,
                    uom,
                    task_value,
                    task_checked,
                    task_notes,
                } = item
                this.itemModel = {
                    ...defaultItemModel,
                    id,
                    name,
                    order_item_type_id,
                    master_item_id,
                    hash,
                    description,
                    section_from_id,
                    section_to_id,
                    quantity,
                    uom,
                    price,
                    assets,
                    task_value,
                    task_checked,
                    task_notes,
                }
            } else {
                this.itemModel = {
                    ...defaultItemModel,
                }
            }
            console.log('showItem after itemModel', this.itemModel)
        },

        handleOk(evt) {
            // Prevent modal from closing
            evt.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },

        parseItem({
            id: master_item_id,
            name,
            order_item_type_id,
            description,
            selling_price: price,
            quantity,
            task_value,
            task_checked,
            task_notes,
        }) {
            return {
                name,
                order_item_type_id,
                description,
                quantity,
                price,
                master_item_id,
                task_value,
                task_checked,
                task_notes,
            }
        },

        async handleSubmit() {
            // Exit when the form isn't valid
            try {
                this.submitting = true
                console.log('itemModel:', this.itemModel)
                if (this.useOfficerList) {
                    await Promise.all(
                        this.selectedItems
                            .map(this.parseItem)
                            .map(this.mergeItem)
                    )
                } else {
                    await this.mergeItem({ ...this.itemModel })
                }
                this.itemVisible = false
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.submitting = false
            }
        },

        async mergeItem(item) {
            try {
                console.log('add item', item)
                this.submitting = true

                item.price = parseFloat(item.price) || 0
                item.quantity = parseInt(item.quantity) || 0

                if (!item.name) {
                    throw new Error('Name is required')
                }

                if (!item.order_item_type_id) {
                    throw new Error('Type is required')
                }

                if (
                    item.section_from_id &&
                    item.section_to_id &&
                    item.section_from_id === item.section_to_id
                ) {
                    throw new Error(
                        'From Section cannot be the same as the To Section'
                    )
                }
                await this.$store.dispatch('orderItemStore/merge', item)
                this.itemVisible = false
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.submitting = false
            }
        },
    },
}
</script>
